import React from 'react';
import { Formik } from 'formik';
import { Modal } from '@oforce/global-components';

import { GraphQLErrors } from '../../../components';

import InvoiceTemplateForm from './InvoiceTemplateForm';
import { useUploadInvoiceTemplate } from '../hooks';

export default function UploadInvoiceTemplate({ isOpen, toggle, clientProductId, hasInvoiceTemplate }) {
  const { uploadInvoiceTemplate, loading, error, initialValues, validationSchema } = useUploadInvoiceTemplate({
    onCompleted: toggle,
    clientProductId
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={uploadInvoiceTemplate}
    >
      {formik => (
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          title={`${hasInvoiceTemplate ? 'Replace' : 'Upload'} Invoice Template`}
          loading={loading}
          onSubmit={formik.handleSubmit}
          submitButtonText="Upload Template"
        >
          {error && <GraphQLErrors error={error} />}
          <InvoiceTemplateForm loading={loading} />
        </Modal>
      )}
    </Formik>
  );
}
